// ABOUTME: Utility functions for subscription status handling and display
// ABOUTME: Provides consistent color mapping and formatting for subscription statuses across admin UI

/**
 * Get the Material UI chip color for a subscription status
 * Matches color scheme from SubscriptionStatusBanner component
 * @param status The subscription status string
 * @returns Material UI chip color name
 */
export const getSubscriptionStatusColor = (
  status: string
): 'success' | 'info' | 'secondary' | 'warning' | 'error' | 'default' => {
  switch (status?.toLowerCase()) {
    case 'active':
      return 'success'; // Green
    case 'trial':
      return 'warning'; // Yellow
    case 'cancelled':
      return 'warning'; // Orange (using warning for yellow/orange in Chip)
    case 'expired':
    case 'refunded':
    case 'paused':
      return 'error'; // Red
    case 'past_due':
      return 'secondary'; // Purple
    case 'free':
      return 'info'; // Blue
    default:
      return 'default';
  }
};

/**
 * Format subscription status for display (capitalize and replace underscores)
 * @param status The subscription status string
 * @returns Formatted status string
 */
export const formatSubscriptionStatus = (status: string): string => {
  if (!status) return 'Unknown';
  return status.charAt(0).toUpperCase() + status.slice(1).replace('_', ' ');
};
